import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";

export class ViewDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    handleOpenEdit = () => {
        console.log("open edit");
        console.log(this.props)
        this.props.agGridReact.props.getRowDetails(this.props.data)
    };

    render() {
        return (
            <>
                <Button
                    onClick={this.handleOpenEdit}
                    disabled={this.props?.data?.status == 'Created' || this.props?.data?.status == 'Rejected' ? true : false}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <Icon name="eye" color="blue" />
                </Button>
            </>
        );
    }
}

export default ViewDetails;
